import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import HandshakeIcon from '@mui/icons-material/Handshake';
import LanguageIcon from '@mui/icons-material/Language';

export default function ContactSection() {
  return (
    <>
      <section id='contact' className="relative py-24 px-4 sm:px-8 overflow-hidden"  style={{ backgroundColor: "#eec0c8" }}>
        {/* Animated blobs */}
        <div className="absolute -top-32 -right-32 w-[600px] h-[600px] bg-pink-100 opacity-30 rounded-full blur-3xl animate-[blob_22s_infinite] z-0"></div>
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] bg-white opacity-20 rounded-full blur-3xl animate-[blob_26s_infinite] z-0"></div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12">
            <span className="text-pink-500">מחכה לשמוע</span>{" "}
            <span className="bg-pink-500 text-white px-2 rounded">ממך</span>{" "}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
            {/* Contact Info */}
            <div className="bg-white shadow-md rounded-xl p-8 space-y-6">
              <div className="flex items-start gap-3">
                <HandshakeIcon className="text-yellow-500 mt-1" />
                <div>
                  <h3 className="text-xl font-bold text-pink-600 mb-2">בואו נתחבר</h3>
                  <p className="text-gray-700">
                    אני תמיד פתוחה לשוחח על פרויקטים חדשים, רעיונות יצירתיים או הזדמנויות להיות חלק מהחזון שלכם.
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <EmailIcon className="text-blue-600" />
                <div>
                  <h4 className="font-semibold text-pink-500">אימייל</h4>
                  <a href='mailto:efratgreenhut1@gmail.com' >
                  <p className="text-gray-800">efratgreenhut1@gmail.com</p>
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <PhoneIcon className="text-green-600" />
                <div>
                  <h4 className="font-semibold text-pink-500">טלפון</h4>
                  <a className="text-gray-800" href="tel:+972506519065">
                    <p >0506519065</p>
                    </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <LanguageIcon className="text-purple-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-pink-500">עקבו אחריי</h4>
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mt-1">
                    <a href="https://www.instagram.com/efratgr/" className="flex items-center gap-1 text-blue-700 hover:text-blue-800 transition">
                      <InstagramIcon className="text-pink-500" fontSize="small" /> אינסטגרם
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61577980238219" className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition">
                      <FacebookIcon className="text-blue-600" fontSize="small" /> פייסבוק
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <form className="bg-white shadow-md rounded-xl p-8 space-y-6">
              <div>
                <label className="block text-pink-600 font-medium mb-1" htmlFor="name">
                  שם
                </label>
                <input
                  type="text"
                  id="name"
                  required
                  className="w-full px-4 py-2 border border-pink-200 rounded-md focus:ring-2 focus:ring-pink-300 focus:outline-none"
                />
              </div>

              <div>
                <label className="block text-pink-600 font-medium mb-1" htmlFor="email">
                  אימייל
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  className="w-full px-4 py-2 border border-pink-200 rounded-md focus:ring-2 focus:ring-pink-300 focus:outline-none"
                />
              </div>

              <div>
                <label className="block text-pink-600 font-medium mb-1" htmlFor="message">
                  הודעה
                </label>
                <textarea
                  id="message"
                  rows="5"
                  required
                  className="w-full px-4 py-2 border border-pink-200 rounded-md focus:ring-2 focus:ring-pink-300 focus:outline-none"
                />
              </div>

              <button
                type="submit"
                onClick={()=> {alert('עקב תקלה זמנית, לא ניתן לשלוח מייל דרך האתר. מוזמנים ליצור קשר דרך המייל שלכם ישירות או דרך הטלפון.')}}
                className="w-full bg-pink-500 hover:bg-pink-600 text-white font-semibold py-3 rounded-md transition shadow-md"
              >
                שליחת מייל
              </button>
            </form>
          </div>
        </div>

        {/* Keyframes for animated blobs */}
        <style>{`
          @keyframes blob {
            0%, 100% {
              transform: scale(1) translate(0px, 0px);
            }
            50% {
              transform: scale(1.05) translate(-20px, 10px);
            }
          }
        `}</style>
      </section>
    </>
  );
}
